export const viewModeType = {
    New : "NEW",
    Edit : "EDIT"
};